export const containClassInElementTree = (element, classname) => {
  if (
    typeof element.className === "string" &&
    element.className.split(" ").indexOf(classname) >= 0
  ) {
    return true;
  }

  return (
    element.parentNode &&
    containClassInElementTree(element.parentNode, classname)
  );
};
